export default "__VITE_ASSET__Clky9BHu__"